<p-dialog
    [(visible)]="visible"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '36rem' }"
    [modal]="true"
    class="p-fluid"
    [resizable]="false"
    [draggable]="false"
    (onHide)="fechar()"
>
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2 w-full">
            <span class="text-xl font-semibold text-900">BLOQUEIO - {{bloqueio?.nomeProfissional}}</span>
            <div
                class="flex align-items-center gap-1 px-2 py-1 border-1 surface-border border-round"
            >
                <i class="pi pi-calendar text-700"></i>
                <span class="text-900 text-base">
                    {{ bloqueio?.dataBloqueio | date : "dd/MM/yyyy" }}
                </span>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages
            [(value)]="messagesDialog"
            [enableService]="false"
            [closable]="true"
        ></p-messages>
        <div class="card">
            <div class="flex flex-column gap-2">
                <span class="text-900 font-semibold">
                    <i class="pi pi-clock"></i>
                    {{bloqueio?.horaInicio?.substring(0,5) }} - {{bloqueio?.horaFim?.substring(0,5) }}
                </span>

                <span class="text-900">
                    {{bloqueio?.descricao}}
                </span>
            </div>
            <div class="flex justify-content-end">
                <button
                    pButton
                    pRipple
                    pTooltip="Excluir"
                    icon="pi pi-trash"
                    class="p-button-danger w-2rem h-2rem"
                    (click)="excluirBloqueio()"
                ></button>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer"></ng-template>
</p-dialog>